import {
    Autocomplete,
    AutocompleteRenderInputParams, capitalize,
    ListItem,
    ListItemText,
    TextField
} from "@mui/material";
import {FieldProps} from "formik";
import {useMemo, useState} from "react";
import {OnboardingAufgaben, OnboardingAufgabeOption} from "../../models/OnboardingAufgaben";
import {useOnboardingHandling} from "../../hooks/onboarding/useOnboardingHandling";

interface OnboardingAufgabenSelectProps extends FieldProps {
    label: string;
    required?: boolean;
    disabled?: boolean;
}

function OnboardingAufgabenSelect({
                            field,
                            form,
                            label,
                            required,
                            disabled,
                        }: OnboardingAufgabenSelectProps) {
    const {translation} = useOnboardingHandling();

    const options = useMemo(() => OnboardingAufgaben.map((value: OnboardingAufgabeOption) => ({
        id: value.id,
        translation: value.translation,
    })), []);

    const selectedOption: OnboardingAufgabeOption | null = options.find(opt => opt.id === field.value) || null;
    const [inputValue, setInputValue] = useState<string>(selectedOption?.translation || "");

    return (
        <Autocomplete
            size="medium"
            options={options}
            autoHighlight
            disabled={disabled}
            getOptionLabel={(option) => capitalize(translation(option.translation))}
            value={selectedOption}
            inputValue={inputValue}
            onInputChange={(_, value) => setInputValue(value)}
            onChange={(_, newValue) => {
                form.setFieldValue(field.name, newValue ? newValue.id : "");
            }}
            renderOption={(props, option) => (
                <ListItem {...props} key={option.id}>
                    <ListItemText primary={capitalize(translation(option.translation))}/>
                </ListItem>
            )}
            renderInput={(params: AutocompleteRenderInputParams) => (
                <TextField
                    {...params}
                    label={label + (required ? " *" : "")}
                    error={!!(form.touched[field.name] && form.errors[field.name])}
                />
            )}
        />
    );
}

export default OnboardingAufgabenSelect;
